/* eslint-disable */
import PropTypes from 'prop-types';
import {
  ESTADOS,
  PROCESOS_ESPECIFICOS,
  TIPO_MONITOREOS,
  UNIDADES_MEDIDA
} from 'constants/nombresCatalogos';
import { useEffect, useState, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Table, Button, Input, Checkbox, SelectTamanoPagina, Tooltip, Form } from 'components';
import { DatePicker, Select, message, Spin } from 'antd';
import InfoModal from 'components/InfoModal/InfoModal';
import {
  getMonitoreosMediosImp,
  getMuestrasByidMonitoreo,
  validarHallazgosByMoni,
  cancelMonitoring
} from 'actions/monitoreos.actions';
import { selectMenuState } from 'selectors/auth.selector';
import {
  DownloadOutlined,
  EyeOutlined,
  EditOutlined,
  CloseCircleOutlined,
  BellOutlined
} from '@ant-design/icons';
import { DATE_FORMAT_COLUMN_TABLE, DATE_FORMAT_DATE_PICKER } from 'constants/dateFormat';
import { useDebounce } from 'hooks/useDebounce';
import * as MensGrales from 'constants/MensajesGenerales';
import { filterList } from 'utils/filterList';
import { getFolioNumber } from 'utils/getFolioNumber';
import { getMenuPermissions } from 'utils/getMenuPermissions';
import {
  NOMBRE_MENU_MEDIOS_IMPRESOS,
  NOMBRE_MENU_PERMISO_EDITAR,
  NOMBRE_MENU_PERMISO_ELIMINAR,
  NOMBRE_MENU_PERMISO_CAPTURAR,
  NOMBRE_MENU_PERMISO_VALIDAR,
  NOMBRE_MENU_PERMISO_NOTIFICAR
} from 'constants/menuNombres';
import { PARCIALMENTE_NOTIFICADO, NOTIFICADO } from 'constants/notificarPartidos';
import { selectCatalogByName, selectCatalogs } from 'selectors/catalogos.selectors';
import { MONITOREOS_MEDIOS_IMPRESOS } from 'constants/tipoMonitoreos';
import { downloadExcelMonitoreos } from 'actions/files.actions';
import { base64toBlob } from 'utils/file';
import './TablaMonitoreo.scss';
import dayjs from 'dayjs';
import { selectMonitoreosMediosImpState } from 'selectors/monitoreosMediosImp.selector';
import { DATE_FORMAT_FILTER_COLUMN, DATE_STRING_TO_MOMENT } from 'utils/date';
import { DescripcionEnlacesModal } from 'components/GeneracionEnlaces/DescripcionEnlacesModal';
import { DescargaPDF, ModalPdf } from 'components/ModalPdf/ModalPdf';
import { getPdfActa } from 'actions/pdf.actions';
import { DOWNLOAD_TYPES } from 'constants/downloadTypes';
import { PDF_MEDIOS_IMPRESOS } from 'constants/pdfTypes';
import { useSetBeneficiados } from 'hooks/useSetBeneficiados';
import CancelModalMonitoring from 'components/CancelModalMonitoring/CancelModalMonitoring';
import ModalNotificarPartido from 'components/ModalNotificarPartido/ModalNotificarPartido';
import { TIPO_MEDIOS_IMPRESOS } from 'constants/notificarPartidos';
import { ModalEditarMedImp } from './ModalEditarMedImp/ModalEditarMedImp';
import { imgDefaultVideo } from './modalVideo';
import ModalNvoMedImp from './ModalFormularioMedImp/ModalNvoMedImp';

import {
  HALLAZGO_VALIDADO,
  HALLAZGO_NO_VALIDADO,
  HALLAZGO_CANCELADO
} from 'constants/estatusHallazgos';

// MNI - Genera formatos PDF al validar
import { generarPDFMonitoreosValidacion } from 'services/monitoreos.service';

const DEBOUNCE_TIME_FILTER = 2000;
dayjs.locale('es');
export const TablaMonitoreo = ({ mainFilters, seleccion, onProcesarTodoChange }) => {
  const filtersRef = useRef({});
  const notificar = useRef({});
  const validar = useRef({});
  const [formEditar] = Form.useForm();
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);
  const [isModalNewOpen, setIsModalNewOpen] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [pdfActa, setPdfActa] = useState(null);
  const [isModalPdfOpen, setIsModalPdfOpen] = useState(false);
  const [isMonitoreoId, setIsMonitoreoId] = useState(null);
  const [isHallazgoId, setIsHallazgoId] = useState(null);
  const [filters, setFilters] = useState({});
  const [folioCancelar, setFolioCancelar] = useState(null);
  const [monitoreoCancelar, setMonitoreoCancelar] = useState(null);
  const [successCancelar, setSuccessCancelar] = useState(false);
  const procesosEspe = useSelector(selectCatalogByName(PROCESOS_ESPECIFICOS));
  const estados = useSelector(selectCatalogByName(ESTADOS));
  const catMonitoreos = useSelector(selectCatalogByName(TIPO_MONITOREOS));
  const catUnidadesMedida = useSelector(selectCatalogByName(UNIDADES_MEDIDA)); // Campo "tipo de medida"

  const menu = useSelector(selectMenuState);
  const catalogos = useSelector(selectCatalogs);
  const [messageApi, contextHolder] = message.useMessage();
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [disableBtnVali, setDisableBtnVali] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [refreshTableKey, setRefreshTableKey] = useState(0);
  const [isVisibleSuccesModal, setIsVisibleSuccessModal] = useState(false);
  const [checkedListDescargas, setCheckedListDescargas] = useState([]);
  const [checkedListNotificar, setCheckedListNotificar] = useState([]);
  const [checkedListValidar, setCheckedListValidar] = useState([]);
  // Se agregan variables de el modal
  const [medioToEdit, setMedioToEdit] = useState(null);
  const [dataBeneficiados, setDataBeneficiados] = useState([]);
  const [catNombreMedImp, setCatNombreMedImp] = useState(null);
  const [nombreMedImpEsOtro, setNombreMedImpEsOtro] = useState(false);
  const [idEstatusHallazgo, setIdEstatusHallazgo] = useState(null);
  const [reasonCancelField, setReasonCancelField] = useState(null);
  const [disableButtonNotificar, setDisableButtonNotificar] = useState(true);
  const [visibleModalNotificar, setVisibleModalNotificar] = useState(false);
  // Catálogo para campo "Tipo de medio impreso"
  let catTipoMedioImp = null;

  for (let i = 0; i < catMonitoreos.length; i += 1) {
    if (catMonitoreos[i].idTipoMonitoreo === 2) {
      // tipoHallazgos
      catTipoMedioImp = catMonitoreos[i].tipoHallazgos;
      break;
    }
  }

  const catalogosStore = {};
  catalogosStore.procesosEspe = procesosEspe;
  catalogosStore.estados = estados;
  catalogosStore.catBeneficiados = catalogos.data.beneficiados;
  catalogosStore.catMonitoreos = catMonitoreos;

  const { loading, data } = useSelector(selectMonitoreosMediosImpState);
  const allOptions = data;
  const checkAllOptionsDescargas =
    allOptions.length === checkedListDescargas.length && allOptions.length !== 0;
  const indeterminateDescargas =
    checkedListDescargas.length > 0 && checkedListDescargas.length < allOptions.length;

  const allOptionsNotificar = data.filter(
    (monitoreo) => monitoreo.estatusCheck === 'Validado' && monitoreo.notificarPartido !== NOTIFICADO
  );
  const notificadosParcialmente = allOptionsNotificar.filter((item) => item.notificarPartido === PARCIALMENTE_NOTIFICADO);
  // console.log('allOptionsNotificar', allOptionsNotificar, notificadosParcialmente);
  const checkAllOptionsNotificar =
    allOptionsNotificar.length === checkedListNotificar.length && allOptionsNotificar.length !== 0;
  const indeterminateNotificar =
    (checkedListNotificar.length > 0 && checkedListNotificar.length < allOptionsNotificar.length) ||
    notificadosParcialmente?.length > 0;

  const allOptionsValidar = data.filter(
    (monitoreo) =>
      monitoreo.hallazgos && monitoreo.hallazgos.length > 0 && monitoreo.hallazgos[0].estatus === 2
  );
  const allOptionsValidados = data.filter(
    (monitoreo) =>
      monitoreo.hallazgos && monitoreo.hallazgos.length > 0 && monitoreo.hallazgos[0].estatus === 4
  );
  const checkAllOptionsValidar =
    allOptionsValidar.length === checkedListValidar.length && allOptionsValidar.length !== 0;
  const indeterminateValidar =
    checkedListValidar.length > 0 && checkedListValidar.length < allOptionsValidar.length;

  const tienePermisoValidar = getMenuPermissions(
    menu,
    NOMBRE_MENU_MEDIOS_IMPRESOS,
    null,
    NOMBRE_MENU_PERMISO_VALIDAR
  );

  const tienePermisoEditar = getMenuPermissions(
    menu,
    NOMBRE_MENU_MEDIOS_IMPRESOS,
    null,
    NOMBRE_MENU_PERMISO_EDITAR
  );

  const tienePermisoNotificar = getMenuPermissions(
    menu,
    NOMBRE_MENU_MEDIOS_IMPRESOS,
    null,
    NOMBRE_MENU_PERMISO_NOTIFICAR
  );

  const showTotal = (total, range) => {
    return `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`;
  };

  const [pagination, setPagination] = useState({
    position: ['bottomRight'],
    showQuickJumper: true,
    size: 'small',
    pageSize: 10,
    current: 1,
    showTotal,
    total: 0,
    showSizeChanger: false
  });
  // console.log('noti', notificar);

  const applyFilter = useDebounce((fields) => setFilters(fields), DEBOUNCE_TIME_FILTER);
  const dispatch = useDispatch();

  const handleChangePageSize = (pageSize) => {
    setPagination((prevPagination) => ({ ...prevPagination, pageSize, current: 1 }));
  };

  function getNameMedImpById(catalogo, id) {
    let nombre = id;
    for (let k = 0; k < catalogo.length; k += 1) {
      if (catalogo[k].idHallazgo === id) {
        nombre = catalogo[k].nombreHallazgo;
        break;
      }
    }
    return nombre;
  }

  const setBeneficiados = useSetBeneficiados();

  function getDescripcionMedidaById(catalogo, id) {
    let respuesta = id;
    for (let i = 0; i < catalogo.length; i += 1) {
      if (catalogo[i].idUnidadMedida === id) {
        respuesta = catalogo[i].descripcion;
        break;
      }
    }
    return respuesta;
  }

  const arregloValoraciones = (valoracionesString) => {
    const valoraciones = valoracionesString !== null ? valoracionesString?.split(',') : null;
    const valoracionesArrayInt = [];
    if (valoracionesString !== null && valoracionesString !== undefined) {
      valoraciones.forEach((valoracion) => valoracionesArrayInt.push(Number(valoracion)));
      return valoracionesArrayInt;
    }
    return null;
  };

  const adaptImage = (image) => {
    if (image === undefined) return null;
    const codeUploadFile = {};
    codeUploadFile.uid = image.idMuestra;
    codeUploadFile.name =
      image.tipoMuestra === 4 ? `${image.idMuestra}_video.mp4` : `${image.idMuestra}_image.png`;

    codeUploadFile.status = 'done';

    codeUploadFile.url =
      image.tipoMuestra === 4
        ? `data:video/mp4;base64,${image.muestra}`
        : `data:image/jpeg;base64,${image.muestra}`;

    codeUploadFile.thumbUrl =
      image.tipoMuestra === 4 ? `${imgDefaultVideo}` : `data:image/jpeg;base64,${image.muestra}`;

    codeUploadFile.type = image.tipoMuestra === 4 ? `video/mp4` : `image/png`;

    return codeUploadFile;
  };

  const handleEditar = async (record) => {
    try {
      setLoadingModal(true);
      setIsFormModalVisible(true);
      setMedioToEdit(record);
      let medidaDisabled = ''; // Campo medida que se muestra en los formModal
      if (catMonitoreos[1] && catMonitoreos[1].tiposMedida) {
        // eslint-disable-next-line array-callback-return
        catMonitoreos[1]?.tiposMedida.map((x) => {
          if (x.idTipoMedida === record.hallazgos[0].idTipoMedida) {
            medidaDisabled = x.medida;
          }
        });
      }

      setCatNombreMedImp(
        catTipoMedioImp.filter(
          (medio) => medio.idHallazgo === record.hallazgos[0].idTipoHallazgo
        )[0].subTipoHallazgos
      );
      setNombreMedImpEsOtro(record.hallazgos[0].idSubTipoHallazgo === 0);
      const respuesta = await dispatch(
        getMuestrasByidMonitoreo({
          hallazgo: {
            idMonitoreo: record.idMonitoreo,
            idHallazgo: record.hallazgos[0].idHallazgo
          }
        })
      );
      const imagenesMuestras = respuesta.response.data.hallazgo.muestras;
      const dataEdicion = {
        fechaRegistro: record.fechaRegistro,
        idProcesoGral: record.idProcesoGral,
        descripcionProcesoGral: record.descripcionProcesoGral,
        estado: record.estado,
        motivoCancelacionEditar: record.hallazgos[0].motivoCancelacion,
        idDistritoLoc: record.hallazgos[0].idDistritoLoc,
        idDistritoFed: record.hallazgos[0].idDistritoFed,
        estatusHallazgo: record.hallazgos[0].estatus,
        // idProcesoEspecifico: getNombreProcesoEspById(record.hallazgos[0].idProcesoEspecifico),
        idProcesoEspecifico: record.hallazgos[0].idProcesoEspecifico,
        idPeriodo: record.hallazgos[0].idPeriodo,
        otroPeriodo:
          record.hallazgos[0].idPeriodo !== 0
            ? []
            : [
                dayjs(record.hallazgos[0]?.inicioOtroPeriodo, DATE_STRING_TO_MOMENT),
                dayjs(record.hallazgos[0]?.finOtroPeriodo, DATE_STRING_TO_MOMENT)
              ],
        inicioOtroPeriodo: dayjs(record.hallazgos[0]?.inicioOtroPeriodo, DATE_STRING_TO_MOMENT),
        finOtroPeriodo: dayjs(record.hallazgos[0]?.finOtroPeriodo, DATE_STRING_TO_MOMENT),
        ambito: record.hallazgos[0].ambito,
        idAmbito: record.hallazgos[0].idAmbito,
        idEstado: record.idEstado,
        // tipoBeneficio: getTipoBeneficioById(record.hallazgos[0]?.beneficiados[0]?.idTipoAsociacion),
        idTipoMedioImpreso: getNameMedImpById(catTipoMedioImp, record.hallazgos[0].idTipoHallazgo),
        idTipoHallazgo: record.hallazgos[0].idTipoHallazgo,
        idSubTipoHallazgo: record.hallazgos[0].idSubTipoHallazgo,
        tipoMedioImpreso: record.hallazgos[0].tipoMedioImpreso,
        otroTipoHallazgo: record.hallazgos[0]?.otroTipoHallazgo,
        // otroSubTipoHallazgo:
        //   record.hallazgos[0]?.otroSubTipoHallazgo != null
        //     ? record.hallazgos[0]?.otroSubTipoHallazgo
        //     : record.hallazgos[0]?.subTipoHallazgo,
        otroSubTipoHallazgo: record.hallazgos[0]?.otroSubTipoHallazgo,
        seccion: record.hallazgos[0].seccion,
        medidaN: medidaDisabled,
        pagina: record.hallazgos[0].pagina,
        cantidad: record.hallazgos[0].cantidad,
        editorial: record.hallazgos[0].editorial,
        fechaPublicacion: record.hallazgos[0]?.fechaPublicacion
          ? dayjs(record.hallazgos[0]?.fechaPublicacion, DATE_STRING_TO_MOMENT)
          : null,
        tipoMedida: getDescripcionMedidaById(catUnidadesMedida, record.hallazgos[0].tipoMedida),
        idTipoMedida: record.hallazgos[0].idTipoMedida,
        leyendaPagada: record.hallazgos[0].leyendaPagada,
        responsablePago: record.hallazgos[0].responsablePago,
        tipoValoracion: record.hallazgos[0].tipoValoracion,
        lema: record.hallazgos[0].lema,
        tipo_beneficio: record.hallazgos[0].tipoBeneficio,
        infAdicional: record.hallazgos[0].infAdicional,
        valoraciones: arregloValoraciones(record.hallazgos[0].valoraciones),
        validacionCNCS: record.hallazgos[0].validacionCNCS,
        idMuestra1: imagenesMuestras?.[0]?.idMuestra,
        idMuestra2: imagenesMuestras?.[1]?.idMuestra,
        idMuestra3: imagenesMuestras?.[2]?.idMuestra,
        idMuestra4: imagenesMuestras?.[3]?.idMuestra,
        idMuestra5: imagenesMuestras?.[4]?.idMuestra,
        muestra1: {
          fileList: [adaptImage(imagenesMuestras?.[0])],
          idMuestra: imagenesMuestras?.[0]?.idMuestra
        },
        muestra2: {
          fileList: [adaptImage(imagenesMuestras?.[1])],
          idMuestra: imagenesMuestras?.[1]?.idMuestra
        },
        muestra3:
          imagenesMuestras?.[2] === undefined
            ? null
            : { fileList: [adaptImage(imagenesMuestras?.[2])] },
        muestra4:
          imagenesMuestras?.[3] === undefined
            ? null
            : { fileList: [adaptImage(imagenesMuestras?.[3])] },
        muestra5:
          imagenesMuestras?.[4] === undefined
            ? null
            : { fileList: [adaptImage(imagenesMuestras?.[4])] }
      };

      // setImagenes();
      formEditar.setFieldsValue(dataEdicion);
      setBeneficiados(
        record.hallazgos[0].beneficiados,
        record.hallazgos[0].tipoBeneficio,
        formEditar
      );
      setDataBeneficiados(record.hallazgos[0].beneficiados, record.hallazgos[0].tipoBeneficio);
    } catch (error) {
      console.log('error', error);
      messageApi.error(MensGrales.ERROR_GET_MUESTRAS);
    }
    setLoadingModal(false);
  };

  const handleOpenModal = () => {
    setIsModalNewOpen(true);
  };

  const handleChangeFilter = ({ target }) => {
    const { value, name } = target;
    filtersRef.current[name] = value;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeDateFilter = (date, dataString, name) => {
    // filtersRef.current.fechaRegistro = date;
    filtersRef.current[name] = date;
    applyFilter({ ...filtersRef.current });
  };

  const getOnChangeHandler = (name) => (date, dateString) => {
    handleChangeDateFilter(date, dateString, name);
  };

  const handleChangeEntityFilter = (idEntidad) => {
    if (idEntidad === undefined) {
      filtersRef.current.idEstado = null;
      delete filtersRef.current[idEntidad];
    } else {
      filtersRef.current.idEstado = idEntidad;
    }
    applyFilter({ ...filtersRef.current });
  };

  const handleGetPdfActa = async (idMonitoreo, option, idHallazgo) => {
    const payload = {
      tipoMonitoreo: MONITOREOS_MEDIOS_IMPRESOS,
      tipoActa: null,
      tipoDescarga: DOWNLOAD_TYPES.TESTIGOS.value,
      listaIdMonitoreos: [idMonitoreo]
    };
    try {
      const { success, response } = await dispatch(getPdfActa(payload));

      const { archivo } = response.data;
      if (success) {
        setPdfActa(archivo);

        if (option === 'eyeOutlined') {
          setIsModalPdfOpen(true);
          setIsMonitoreoId(idMonitoreo);
          setIsHallazgoId(idHallazgo);
        }

        if (option === 'downloadOutlined') {
          DescargaPDF(archivo, PDF_MEDIOS_IMPRESOS, idMonitoreo, idHallazgo);
        }
      }
    } catch (error) {
      messageApi.error('Error al obtener el PDF', 3);
    }
  };

  const filter = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Input
        id={columnName}
        placeholder="Filtrar"
        name={columnName}
        key={columnName}
        onChange={handleChangeFilter}
      />
    </label>
  );

  const filterDate = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <DatePicker
        id={columnName}
        name={columnName}
        key={columnName}
        placeholder="Filtrar"
        style={{ width: '100%' }}
        allowClear
        onChange={getOnChangeHandler(columnName)}
        format={DATE_FORMAT_DATE_PICKER}
      />
    </label>
  );

  const filterEntity = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Select
        placeholder="Filtrar"
        options={estados}
        onChange={handleChangeEntityFilter}
        allowClear
        style={{ width: '100%' }}
        fieldNames={{
          value: 'idEstado',
          label: 'nombreEstado'
        }}
      />
    </label>
  );

  const checkBoxEstatusMonitoreo = (row) => {
    let enableCheckBox = false;
    if (row.estatusCheck !== 'Validado' || row.notificarPartido === NOTIFICADO) {
      enableCheckBox = true;
    }
    return enableCheckBox;
  };

  const onChange = (row, checked, optionType) => {
    switch (optionType) {
      case 'Descargas':
        if (checked) {
          // Si está marcado, agregar el row al checkedList
          setCheckedListDescargas((prevCheckedList) => [...prevCheckedList, row]);
        } else {
          // Si está desmarcado, filtrar el row fuera del checkedList
          setCheckedListDescargas((prevCheckedList) =>
            prevCheckedList.filter((item) => item.idMonitoreo !== row.idMonitoreo)
          );
        }
        break;
      case 'Notificar':
        if (checked) {
          // Si está marcado, agregar el row al checkedList
          setCheckedListNotificar((prevCheckedList) => [...prevCheckedList, row]);
        } else {
          // Si está desmarcado, filtrar el row fuera del checkedList
          setCheckedListNotificar((prevCheckedList) =>
            prevCheckedList.filter((item) => item.idMonitoreo !== row.idMonitoreo)
          );
        }
        break;
      default:
        if (checked) {
          // Si está marcado, agregar el row al checkedList
          setCheckedListValidar((prevCheckedList) => [
            ...prevCheckedList,
            { ...row, esNuevo: true } // Se agrega el campo `esNuevo`
          ]);
        } else {
          // Si está desmarcado, filtrar el row fuera del checkedList
          setCheckedListValidar((prevCheckedList) =>
            prevCheckedList.filter((item) => item.idMonitoreo !== row.idMonitoreo)
          );
        }
    }
  };

  const handleSetProcesarTodo = (valor) => {
    try {
      if (onProcesarTodoChange) {
        onProcesarTodoChange(valor);
      }
    } catch (error) {
      console.log('Error: ', error);
    }
  };

  const onCheckAllChange = (e, optionType) => {
    const newSeleccion = {};
    const newNotificar = {};
    switch (optionType) {
      case 'Descargas':
        if (e.target.checked) {
          allOptions.forEach((item) => {
            newSeleccion[item.idForDescarga] = true;
          });
          // eslint-disable-next-line no-param-reassign
          seleccion.current = newSeleccion;
          handleSetProcesarTodo(true);
        } else {
          allOptions.forEach((item) => {
            newSeleccion[item.idForDescarga] = false;
          });
          // eslint-disable-next-line no-param-reassign
          seleccion.current = newSeleccion;
          handleSetProcesarTodo(false);
        }
        setCheckedListDescargas(e.target.checked ? allOptions : []);
        break;
      case 'Notificar':
        // const notificadosParcialmente = allOptionsNotificar.filter(
        //   (item) => item.notificarPartido === 1
        // );
        if (e.target.checked) {
          allOptionsNotificar.forEach((item) => {
            newNotificar[item.idForNotificar] = true;
          });
          notificadosParcialmente.forEach((item) => {
            newNotificar[item.idForNotificar] = true;
          });
          // eslint-disable-next-line no-param-reassign
          // notificar.current = newNotificar;
        } else {
          allOptionsNotificar.forEach((item) => {
            newNotificar[item.idForNotificar] = false;
          });
          // notificar.current = newNotificar;
          notificadosParcialmente.forEach((item) => {
            newNotificar[item.idForNotificar] = false;
          });
        }
        notificar.current = newNotificar;
        setCheckedListNotificar(e.target.checked ? allOptionsNotificar : []);
        break;
      default:
        allOptionsValidados.forEach((item) => {
          newSeleccion[item.idMonitoreo] = true;
        });
        if (e.target.checked) {
          allOptionsValidar.forEach((item) => {
            newSeleccion[item.idMonitoreo] = true;
          });

          // eslint-disable-next-line no-param-reassign
          validar.current = newSeleccion;
        } else {
          allOptionsValidar.forEach((item) => {
            newSeleccion[item.idMonitoreo] = false;
          });
          // eslint-disable-next-line no-param-reassign
          validar.current = newSeleccion;
        }
        setCheckedListValidar(e.target.checked ? allOptionsValidar : []);
    }
  };

  const checkAll = (columnName, lblColumn) => (
    <label className="checkAll" htmlFor={columnName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateDescargas}
        onChange={(e) => onCheckAllChange(e, 'Descargas')}
        checked={checkAllOptionsDescargas}
        disabled={allOptions.length === 0}
      />
    </label>
  );

  const checkAllNotificar = (columName, lblColumn) => (
    <label className="checkAll" htmlFor={columName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateNotificar}
        onChange={(e) => onCheckAllChange(e, 'Notificar')}
        checked={checkAllOptionsNotificar}
        disabled={allOptionsNotificar.length === 0}
      />
    </label>
  );

  const checkAllValidar = (columnName, lblColumn) => (
    <label className="checkAll" htmlFor={columnName}>
      {lblColumn}
      <Checkbox
        className="checkboxAll"
        indeterminate={indeterminateValidar}
        onChange={(e) => onCheckAllChange(e, 'Validar')}
        checked={checkAllOptionsValidar}
        disabled={allOptionsValidar.length === 0}
      />
    </label>
  );

  const renderCheckboxDescarga = (_, row) => (
    <Checkbox
      checked={!!seleccion.current[row.idForDescarga]}
      key={row.idForDescarga}
      onChange={({ target }) => {
        const { current } = seleccion;
        current[row.idForDescarga] = target.checked;
        onChange(row, target.checked, 'Descargas');
      }}
    />
  );

  const handleConfirmCancel = async (comments) => {
    const payload = {
      monitoreos: {
        toCancel: [
          {
            pkMonitoreo: monitoreoCancelar,
            idMonitoreo: monitoreoCancelar,
            motivoCancelacion: comments.motivo
          }
        ]
      }
    };
    const { success, response } = await dispatch(cancelMonitoring(payload));
    if (success && response?.data.code === 200) {
      setMonitoreoCancelar(null);
      setSuccessCancelar(true);
      dispatch(getMonitoreosMediosImp(pagination.current, pagination.pageSize));
    } else if (response?.causa !== undefined) {
      messageApi.error(response.causa);
    } else {
      messageApi.error(MensGrales.MAV1_2);
    }
  };

  const handleCloseModal = () => {
    getDataMediosImpresos();
  };

  const handleCancelMonitoring = (cancelData) => {
    setMonitoreoCancelar(cancelData);
  };

  let checkVal = [];
  let monChecked = null;

  const renderCheckboxValidacion = (_, row) => {
    if (tienePermisoValidar) {
      return (
        <Checkbox
          checked={!!validar.current[row.idMonitoreo] || row.hallazgos[0].estatus === 4}
          key={row.idMonitoreo}
          onChange={({ target }) => {
            const { checked } = target;
            const { current } = validar;
            current[row.idMonitoreo] = target.checked;
            onChange(row, target.checked, 'Validar');
            if (checked) {
              checkVal.push(row.idMonitoreo);
              monChecked = row;
            } else {
              checkVal = checkVal.filter((id) => id !== row.idMonitoreo);
              monChecked = null;
            }
          }}
          disabled={
            (row.hallazgos && row.hallazgos.length > 0 && row.hallazgos[0].estatus === 4) ||
            row.estatusMonitoreo === 3
          }
        />
      );
    }
    return <Checkbox disabled />;
  };

  const renderCheckboxNotificar = (_, row) => {
    if (tienePermisoEditar || tienePermisoValidar) {
      return (
        <Checkbox
          checked={
            !!notificar.current[row.idForNotificar] ||
            row.notificarPartido === PARCIALMENTE_NOTIFICADO ||
            row.notificarPartido === NOTIFICADO
          }
          disabled={checkBoxEstatusMonitoreo(row)}
          key={row.idForNotificar}
          onChange={({ target }) => {
            // const { checked } = target;
            const { current } = notificar;
            current[row.idForNotificar] = target.checked;
            onChange(row, target.checked, 'Notificar');
            // if (checked) {
            //   checkVal.push(row.idForNotificar);
            //   monChecked = row;
            // } else {
            //   checkVal = checkVal.filter((id) => id !== row.idForNotificar);
            //   monChecked = null;
            // }
          }}
        />
      );
    }
    return <Checkbox disabled />;
  };

  const onValidarHallazgos = async () => {
    // const monitoreosSeleccionados = checkVal;
    const monitoreosSeleccionados = checkedListValidar.map((item) => item.idMonitoreo);
    if (monitoreosSeleccionados.length === 0) {
      message.error('Debes seleccionar al menos un monitoreo para validar.');
      return;
    }
    if (monitoreosSeleccionados !== null) {
      setDisableBtnVali(true);
      setLoadingTable(true);
      const request = {
        token: '',
        monitoreos: {
          toDeValidate: [],
          toValidate: []
        }
      };
      for (let j = 0; j < monitoreosSeleccionados.length; j += 1) {
        request.monitoreos.toValidate.push({
          pkMonitoreo: monitoreosSeleccionados[j],
          idMonitoreo: monitoreosSeleccionados[j]
        });
      }
      const { success, response } = await dispatch(validarHallazgosByMoni(request));
      if (success && response?.data.code === 200) {
        setTimeout(async () => {
          if (monChecked !== null) {
            monChecked.hallazgos[0].estatus = 4;
          }
          message.success('Los monitoreos se validaron correctamente');
          setRefreshTableKey((prevKey) => prevKey + 1);

          let monitoreoValidar = checkedListValidar.filter((x) => x.esNuevo == true);

          for (let i = 0; i < monitoreoValidar.length; i++) {
            // MNI - Llamado a la generación de PDF's al momento de validar
            let monitoreoPDF = [
              {
                idMonitoreo: monitoreoValidar[i].idMonitoreo,
                idTipoMonitoreo: 2,
                tiposActa: [{ id: 4 }]
              }
            ];

            // Se genera PDF una vez que se han almacenado las Muestras
            let generoPDF = await generarPDFMonitoreosValidacion(monitoreoPDF);
            if (generoPDF) {
              console.log('Se generó correctamente el PDF');
            } else {
              console.log('Error al generar el PDF');
            }
          }

          setLoadingTable(false);
        }, 500);
      } else if (response?.causa !== undefined) {
        messageApi.error(response.causa);
        setLoadingTable(false);
      } else {
        messageApi.error(MensGrales.MAV1_2);
        setLoadingTable(false);
      }
      setDisableBtnVali(false);
    }
  };

  const renderActions = (value, row) => (
    <div className="column-acciones actions-container">
      <Tooltip title="Visualizar" class="tooltip-acciones btn-deleteoutlined" placement="topLeft">
        <Button
          shape="circle"
          onClick={() => {
            messageApi.open({
              content: <Spin />
            });
            const { idMonitoreo, idHallazgo } = row.hallazgos[0];
            handleGetPdfActa(idMonitoreo, 'eyeOutlined', idHallazgo);
          }}
          icon={<EyeOutlined className="icons-tbl-users" />}
          ghost
        />
      </Tooltip>
      {((getMenuPermissions(menu, NOMBRE_MENU_MEDIOS_IMPRESOS, null, NOMBRE_MENU_PERMISO_EDITAR) &&
        row.hallazgos[0]?.estatus !== 4) ||
        ((tienePermisoEditar || tienePermisoValidar) && row.hallazgos[0]?.estatus === 4)) && (
        <Tooltip title="Editar" class="tooltip-acciones btn-deleteoutlined" placement="topLeft">
          <Button
            className="btnTblAccion"
            icon={<EditOutlined className="icons-tbl-users icons-tbl" />}
            ghost
            onClick={() => {
              setIdEstatusHallazgo(row.hallazgos[0].estatus);
              setReasonCancelField(row.hallazgos[0].motivoCancelacion);
              handleEditar(row);
            }}
          />
        </Tooltip>
      )}
      <Tooltip title="Descargar" class="tooltip-acciones btn-deleteoutlined" placement="topLeft">
        <Button
          className="btnTblAccion"
          onClick={() => {
            messageApi.open({
              content: <Spin />
            });
            const { idMonitoreo, idHallazgo } = row.hallazgos[0];
            handleGetPdfActa(idMonitoreo, 'downloadOutlined', idHallazgo);
          }}
          icon={<DownloadOutlined className="icons-tbl-users icons-tbl" />}
          ghost
        />
      </Tooltip>
      {((getMenuPermissions(
        menu,
        NOMBRE_MENU_MEDIOS_IMPRESOS,
        null,
        NOMBRE_MENU_PERMISO_ELIMINAR
      ) &&
        row.hallazgos[0]?.estatus === 2) ||
        (tienePermisoEditar && row.estatusMonitoreo !== 3)) && (
        <Tooltip
          title="Cancelar"
          className="tooltip-acciones btn-deleteoutlined"
          placement="topLeft"
          arrow={{ pointAtCenter: true }}>
          <Button
            shape="circle"
            onClick={() => {
              handleCancelMonitoring(row.idMonitoreo);
              setFolioCancelar(row.folio);
            }}
            icon={<CloseCircleOutlined className="icons-tbl-users" />}
          />
        </Tooltip>
      )}
    </div>
  );

  const construirFechaFromString = (fecha) => {
    if (fecha && fecha !== '') {
      return dayjs(fecha, 'YYYYMMDDHHmmss').format(DATE_FORMAT_FILTER_COLUMN);
    }
    return '';
  };

  const construirPeriodo = (id, inicio, fin) => {
    if (inicio && fin) {
      return `${construirFechaFromString(inicio)} al ${construirFechaFromString(fin)}`;
    }
    return 'Otro';
  };

  const columns = [
    {
      title: filter('folio', 'Folio de monitoreo'),
      key: 'folio',
      dataIndex: 'folio',
      width: '11%',
      className: 'my-column-tbl'
    },
    {
      title: filter('folioCNCS', 'Folio CNCS'),
      dataIndex: 'folioCNCS',
      width: '11%',
      className: 'my-column-tbl',
      key: 'folioCNCS'
    },
    {
      title: filterDate('fechaRegistro', 'Fecha'),
      dataIndex: 'fechaRegistro',
      width: '11%',
      className: 'my-column-tbl',
      render: (d) => d.format(DATE_FORMAT_COLUMN_TABLE),
      key: 'fechaRegistro'
    },
    {
      title: filterDate('fechaSincronizacion', 'Fecha de sincronización'),
      dataIndex: 'fechaSincronizacion',
      width: '11%',
      className: 'my-column-tbl',
      render: (d) => d.format(DATE_FORMAT_COLUMN_TABLE),
      key: 'fechaSincronizacion'
    },
    {
      title: filter('monitor', 'Monitorista'),
      dataIndex: 'monitor',
      width: '10%',
      className: 'my-column-tbl',
      key: 'monitor'
    },
    {
      title: filterEntity('estado', 'Entidad'),
      dataIndex: 'estado',
      width: '8%',
      className: 'my-column-tbl',
      key: 'estado'
    },
    {
      title: filter('periodo', 'Periodo'),
      dataIndex: 'hallazgos',
      width: '10%',
      className: 'my-column-tbl',
      key: 'periodo',
      render: (hallazgo) => (
        <div>
          {hallazgo.map((h) =>
            h.idPeriodo !== 0 ? (
              <span>{construirPeriodo(h.idPeriodo, h.inicioPeriodo, h.finPeriodo)}</span>
            ) : (
              <span>{construirPeriodo(h.idPeriodo, h.inicioOtroPeriodo, h.finOtroPeriodo)}</span>
            )
          )}
        </div>
      )
    },
    {
      title: filter('estatus', 'Estatus'),
      dataIndex: 'estatus',
      align: 'center',
      width: '10%',
      key: 'estatus'
    },
    {
      title: checkAllValidar('aValidar', 'Check de validación'),
      dataIndex: 'aValidar',
      width: '5%',
      className: 'my-column-tbl',
      render: renderCheckboxValidacion,
      key: 'aValidar'
    },
    {
      title: checkAllNotificar('aNotificar', 'Notificar a partido'),
      dataIndex: 'aNotificar',
      width: '5%',
      className: 'my-column-tbl',
      render: renderCheckboxNotificar,
      key: 'aNotificar'
    },
    {
      title: checkAll('descargado', 'Check de descarga'),
      dataIndex: 'checkDescargaAC',
      width: '5%',
      className: 'my-column-tbl',
      render: renderCheckboxDescarga,
      key: 'checkDescargaAC'
    },
    {
      title: 'Acciones',
      key: 'acciones',
      align: 'center',
      width: '7%',
      className: 'my-column-tbl',
      render: renderActions
    }
  ];

  const handleDownloadExcel = async () => {
    setDownloadingExcel(true);
    const { success, response } = await dispatch(
      downloadExcelMonitoreos({ tipoMonitoreo: MONITOREOS_MEDIOS_IMPRESOS })
    );
    if (response !== null && response !== undefined && success) {
      if (response.data.code === 200) {
        if (response.data.excel64) {
          const url = window.URL.createObjectURL(
            base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.excel64.nombre);
          link.click();
          setDownloadingExcel(false);
        }
      }
    }
    setDownloadingExcel(false);
  };

  const allowedColumns = useMemo(() => {
    if (
      !getMenuPermissions(menu, NOMBRE_MENU_MEDIOS_IMPRESOS, null, NOMBRE_MENU_PERMISO_NOTIFICAR)
    ) {
      return columns
        .map((column) =>
          column.key.includes('aNotificar') || column.key.includes('hallazgos') ? null : column
        )
        .filter((column) => column !== null);
    }
    return columns;
  }, [checkedListNotificar, checkedListDescargas, checkedListValidar]);

  const filteredList = useMemo(() => {
    const {
      fechaFinal,
      fechaInicio,
      folioDesde,
      folioHasta,
      idProcesoGral,
      idProcesoEspecifico,
      folioCNCSDesde,
      folioCNCSHasta
    } = mainFilters;
    const filteredData = data.filter((row) => {
      const folio = getFolioNumber(row.folio);
      const folioCNCS = row.folioCNCS.substring(row.folioCNCS.length - 4);
      if (folioDesde && folio < folioDesde) return false;
      if (folioHasta && folio > folioHasta) return false;
      if (folioCNCSDesde && folioCNCS < folioCNCSDesde) return false;
      if (folioCNCSHasta && folioCNCS > folioCNCSHasta) return false;
      if (idProcesoGral && row.idProcesoGral !== idProcesoGral) return false;
      if (idProcesoEspecifico && row.hallazgos?.[0]?.idProcesoEspecifico !== idProcesoEspecifico)
        return false;
      if (fechaFinal && fechaFinal < row.fechaRegistro.format('YYYY-MM-DD 00:01:00.000'))
        return false;
      if (fechaInicio && fechaInicio > row.fechaRegistro.format('YYYY-MM-DD 00:01:00.000'))
        return false;
      return true;
    });
    return filteredData;
  }, [data, mainFilters]);

  const dataList = useMemo(() => {
    const listaFiltrada = filterList(filteredList, filters);
    const rowsToCheckValidar = listaFiltrada.filter(
      (row) => row.hallazgos && row.hallazgos.length > 0 && row.hallazgos[0].estatus === 4
    );

    if (rowsToCheckValidar.length > 0) {
      const { current } = validar;
      rowsToCheckValidar.forEach((item) => {
        current[item.idMonitoreo] = true;
      });
      setCheckedListValidar([]);
    }

    // Obtiene la descripción del estatus según el valor del estatus del hallazgo
    listaFiltrada.forEach((element) => {
      element.estatus = [HALLAZGO_CANCELADO, HALLAZGO_NO_VALIDADO, HALLAZGO_VALIDADO].find(
        (e) => e.value === element.idEstatusCheck
      )?.label;
    });

    return listaFiltrada;
  }, [filteredList, filters]);

  useEffect(() => {
    // const seleccionN = {};
    // checkedListNotificar.forEach((item) => {
    //   seleccionN[item.idForNotificar] = true;
    // });

    const seleccionV = {};
    checkedListValidar.forEach((item) => {
      seleccionV[item.idMonitoreo] = true;
    });
    validar.current = seleccionV;
  }, [dataList]);

  const getDataMediosImpresos = async () => {
    try {
      const { success, totalMonMediosImpresos } = await dispatch(
        getMonitoreosMediosImp(pagination.current, pagination.pageSize)
      );
      if (success && totalMonMediosImpresos > 0) {
        setPagination((prev) => ({
          ...prev,
          total: totalMonMediosImpresos
        }));

        // Cada que cambia la paginación reiniciamos los check a false
        /* Por definición de onCheckAllChange, basta con enviar el objeto eNotificar para restablecer los valores del check Notificar */
        const event = { target: { checked: false } };
        onCheckAllChange(event, 'Notificar');
        onCheckAllChange(event, 'Descargas');
        // if (notificadosParcialmente?.length === 0) setCheckedListNotificar([]);
      }
    } catch (error) {
      console.log('Error', error);
    }
  };
  const onClickButtonNotificarOGenerar = () => {
    notificadosParcialmente.forEach((item) => {
      notificar.current[item.idForNotificar] = true;
    });
    // console.log('notificar', notificar);
  };

  useEffect(() => {
    getDataMediosImpresos();
  }, [refreshTableKey, pagination.current, pagination.pageSize]);

  useEffect(() => {
    if (checkedListNotificar?.length === 0 || notificadosParcialmente?.length === 0) {
      setDisableButtonNotificar(true);
    }
    if (checkedListNotificar?.length > 0 || notificadosParcialmente?.length > 0) {
      setDisableButtonNotificar(false);
    }
  }, [checkedListNotificar]);

  return (
    <div className="tabla-monitoreo">
      <ModalPdf
        open={isModalPdfOpen}
        pdfActa={pdfActa}
        tipoActa={PDF_MEDIOS_IMPRESOS}
        callback={() => setIsModalPdfOpen(false)}
        idActa={isHallazgoId}
        idMonitoreo={isMonitoreoId}
        destroyOnClose
      />
      <ModalNvoMedImp
        title="Agregar"
        open={isModalNewOpen}
        callback={() => setIsModalNewOpen(false)}
        catTipoMedioImp={catTipoMedioImp}
      />
      <ModalNotificarPartido
        visible={visibleModalNotificar}
        seleccion={notificar}
        tipo={TIPO_MEDIOS_IMPRESOS}
        onClose={() => setVisibleModalNotificar(false)}
        getMonitoreos={getDataMediosImpresos}
      />
      <ModalEditarMedImp
        formEditar={formEditar}
        titleModal="Editar"
        isModalOpen={isFormModalVisible}
        setIsModalOpen={setIsFormModalVisible}
        loadingModal={loadingModal}
        medioToEdit={medioToEdit}
        idEstatusHallazgo={idEstatusHallazgo}
        setIdEstatusHallazgo={setIdEstatusHallazgo}
        dataBeneficiados={dataBeneficiados}
        setDataBeneficiados={setDataBeneficiados}
        catNombreMedImp={catNombreMedImp}
        setCatNombreMedImp={setCatNombreMedImp}
        reasonCancelField={reasonCancelField}
        nombreMedImpEsOtro={nombreMedImpEsOtro}
        setNombreMedImpEsOtro={setNombreMedImpEsOtro}
        onClose={handleCloseModal}
      />
      <div>
        <CancelModalMonitoring
          open={monitoreoCancelar}
          title={`¿Estás seguro de cancelar el monitoreo ${folioCancelar}?`}
          cancelConfirm={handleConfirmCancel}
          handleCerrar={() => {
            setMonitoreoCancelar(null);
            setSuccessCancelar(false);
          }}
          openSuccess={successCancelar}
        />
      </div>
      <div className="table-header">
        <div>
          <SelectTamanoPagina
            value={pagination.pageSize}
            onChange={handleChangePageSize}
            disableBottomExcel={downloadingExcel}
            onClick={handleDownloadExcel}
          />
        </div>
        {getMenuPermissions(
          menu,
          NOMBRE_MENU_MEDIOS_IMPRESOS,
          null,
          NOMBRE_MENU_PERMISO_CAPTURAR
        ) && <Button text="Agregar nuevo monitoreo" type="primary" onClick={handleOpenModal} />}
      </div>
      {contextHolder}
      <Table
        key={refreshTableKey}
        bordered={false}
        scroll={{ x: 2000 }}
        columns={allowedColumns}
        dataSource={dataList}
        pagination={{
          ...pagination,
          onChange: (page, pageSize) => {
            setPagination((prev) => ({
              ...prev,
              current: page,
              pageSize: pageSize || prev.pageSize
            }));
          }
        }}
        loading={loading || loadingTable}
      />
      <div className="contenedorBtns">
        {tienePermisoNotificar && (
          <>
            <div className="btnNotificar">
              <Button
                onClick={() => {
                  onClickButtonNotificarOGenerar();
                  setVisibleModalNotificar(true);
                }}
                size="large"
                type="primary"
                text="Enviar notificación"
                icon={<BellOutlined />}
                disabled={disableButtonNotificar || loading}
              />
            </div>
            <div className="btnGenerar">
              <DescripcionEnlacesModal
                seleccion={notificar}
                tipoMonitoreo={MONITOREOS_MEDIOS_IMPRESOS}
                tipoActa={null}
                visible={false}
                disabledButton={disableButtonNotificar || loading}
                onUpdateSeleccion={onClickButtonNotificarOGenerar}
              />
            </div>
          </>
        )}
        <div className="btnValidar">
          {tienePermisoValidar && (
            <Button
              type="primary"
              text="Check de validación"
              size="large"
              loading={loading}
              disabled={disableBtnVali}
              onClick={onValidarHallazgos}
            />
          )}
        </div>
      </div>
      <InfoModal visible={isVisibleSuccesModal} onClose={() => setIsVisibleSuccessModal(false)} />
    </div>
  );
};

TablaMonitoreo.propTypes = {
  mainFilters: PropTypes.shape({
    fechaFinal: PropTypes.shape({}),
    fechaInicio: PropTypes.shape({}),
    folioDesde: PropTypes.number,
    folioHasta: PropTypes.number,
    idProcesoGral: PropTypes.number,
    idProcesoEspecifico: PropTypes.number,
    folioCNCSDesde: PropTypes.number,
    folioCNCSHasta: PropTypes.number
  }).isRequired,
  seleccion: PropTypes.shape({
    current: PropTypes.shape({})
  }).isRequired
};
